export const DirectionType = {
	IN: 1,
	OUT: -1,
};